'use client';

import { useState } from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaYoutube,
} from 'react-icons/fa';
import { connect } from 'react-redux';
import { subscribeUser } from '../../actions/warranty';
import { isValidEmail } from '../../utils/constants';
import { footerColumns } from '../../utils/constants';

const followOptions = [
  {
    icon: <FaInstagram />,
    name: 'Instagram',
    link: 'https://www.instagram.com/gritrtx/',
  },
  {
    icon: <FaFacebookF />,
    name: 'Facebook',
    link: 'https://www.facebook.com/gritrtexas/',
  },
  {
    icon: <FaYoutube />,
    name: 'YouTube',
    link: 'https://www.youtube.com/@gritrtx',
  },
  {
    icon: <FaPinterestP />,
    name: 'Pinterest',
    link: 'https://www.pinterest.com/gritrtx/',
  },
];

const Footer = ({ warranty: { score, loadingSubscribe }, subscribeUser }) => {
  const [email, setEmail] = useState('');
  const [isError, setError] = useState(false);

  const submitEmail = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setError(true);
      return;
    }

    subscribeUser(email);
    setError(false);
    setEmail('');
  };

  return (
    <footer className='footer'>
      <div className='footer-inner'>
        <div className='container'>
          <div className='ob-news-section'>
            <article
              className='footer-info-col'
              data-section-type='newsletterSubscription'
            >
              <h3 className='footer-info-heading'>
                Sign up for our Newsletter
              </h3>
              <p>
                Be the first to hear about GritrGear’s latest and greatest deals
                and products
              </p>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background: '#4f4d4f',
                  padding: '10px 20px',
                  borderRadius: '12px',
                }}
              >
                <input
                  className={`footer-input ${
                    isError ? 'footer-input-error' : ''
                  }`}
                  type='text'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder='Your email'
                />
                <button
                  className='footer-form-btn'
                  onClick={submitEmail}
                  disabled={score < 0.5 || loadingSubscribe ? true : false}
                >
                  JOIN
                </button>
              </div>
            </article>

            <article
              className='footer-info-col footer-info-col--small'
              data-section-type='footer-webPages'
            >
              <h3 className='footer-info-heading'>Follow Us</h3>
              <ul className='socialLinks socialLinks--alt'>
                {followOptions.map((option, index) => (
                  <li className='socialLinks-item' key={index}>
                    <a
                      className={`icon icon--${option.icon}`}
                      href={option.link}
                      rel='noopener'
                      target='blank'
                    >
                      {option.name}
                      {option.icon}
                    </a>
                  </li>
                ))}
              </ul>
            </article>
          </div>
          <div className='ob-nav-section'>
            {footerColumns.map((column, colIndex) => (
              <article
                key={colIndex}
                className='footer-info-col footer-info-col--small'
                data-section-type='footer-categories'
              >
                <h3 className='footer-info-heading'>{column.heading}</h3>
                <ul className='footer-info-list'>
                  {column.items.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      {link.linkText ? (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '5px',
                          }}
                        >
                          <span>{link.label}</span>
                          <a
                            className={`${
                              link.underline ? 'text--underline' : ''
                            } ${link.color ? `text--primary` : ''}`}
                            href={link.href}
                          >
                            {link.linkText}
                          </a>
                        </div>
                      ) : link.isText ? (
                        <span
                          className={`${
                            link.underline ? 'text--underline' : ''
                          }`}
                        >
                          {link.label}
                        </span>
                      ) : (
                        <a
                          className={`${
                            link.underline ? 'text--underline' : ''
                          }`}
                          href={link.href}
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <div className='ob-copyright-section'>
            <div className='footer-copyright footer-store-date'>
              <p className='powered-by'>
                © 2025 GritrGear |{' '}
                <a href='https://gritrgear.com/sitemap.php'>Sitemap</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  warranty: state.warranty,
});

export default connect(mapStateToProps, { subscribeUser })(Footer);
